/* src/app/components/users-component/users-component.css */
.user-roster {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 16px;
  margin-top: 22px;
}
.user-card {
  border: 1px solid rgba(212, 175, 55, 0.16);
  border-radius: 16px;
  overflow: hidden;
  background:
    linear-gradient(
      180deg,
      rgba(56, 38, 27, 0.92) 0%,
      rgba(28, 22, 18, 0.96) 100%);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.24);
}
.user-card-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 18px 18px 12px;
  border-bottom: 1px solid rgba(212, 175, 55, 0.14);
  background: rgba(255, 255, 255, 0.03);
}
.user-card-header h3 {
  margin: 2px 0 0;
  color: #fbf4df;
}
.user-kicker {
  color: var(--gold);
  font-size: 0.78rem;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}
.user-id {
  padding: 6px 10px;
  border-radius: 999px;
  border: 1px solid rgba(212, 175, 55, 0.18);
  background: rgba(0, 0, 0, 0.18);
  color: var(--ink-soft);
  font-size: 0.8rem;
  white-space: nowrap;
}
.user-card-body {
  padding: 16px 18px 18px;
}
.user-card-body p {
  margin: 0 0 12px;
}
.role-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.role-badge {
  display: inline-flex;
  align-items: center;
  padding: 6px 10px;
  border-radius: 999px;
  background: rgba(212, 175, 55, 0.12);
  border: 1px solid rgba(212, 175, 55, 0.22);
  color: var(--gold-bright);
  font-size: 0.82rem;
  letter-spacing: 0.04em;
}
.role-empty {
  color: var(--ink-soft);
  font-style: italic;
}
/*# sourceMappingURL=users-component.css.map */
